import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PropertyProvider } from './context/PropertyContext';
import { UserProvider } from './context/UserContext';
import { CondominiumProvider } from './context/CondominiumContext';
import { ClientProvider } from './context/ClientContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SearchPage from './pages/SearchPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import TourVirtualPage from './pages/TourVirtualPage';
import ToursPage from './pages/ToursPage';
import TourViewPage from './pages/TourViewPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import XmlFeedPage from './pages/XmlFeedPage';
import TrabalheConoscoPage from './pages/TrabalheConoscoPage';
import VagasPage from './pages/VagasPage';
import VagaDetalhePage from './pages/VagaDetalhePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import FichasCaptacaoPage from './pages/FichasCaptacaoPage';
import PublicFormPage from './pages/PublicFormPage';
import RevisaoContratoPage from './pages/RevisaoContratoPage';
import GoogleCalendarCallback from './components/GoogleCalendarCallback';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import PWAUpdateNotification from './components/PWAUpdateNotification';
import { Toaster } from './components/ui/toaster';
import { useAutoSubscribePush } from './hooks/useAutoSubscribePush';

function App() {
  console.log('🚀 App: Iniciando aplicação...');
  // Ativa push notifications automaticamente para usuários logados
  useAutoSubscribePush();
  
  return (
    <ErrorBoundary>
      <AuthProvider>
      <UserProvider>
        <ClientProvider>
          <CondominiumProvider>
            <PropertyProvider>
              <Router>
                <div className="min-h-screen bg-background">
                  <Routes>
                    <Route path="/dashboard" element={
                      <ProtectedRoute>
                        <DashboardPage />
                      </ProtectedRoute>
                    } />
                    <Route path="/fichas-captacao" element={
                      <ProtectedRoute>
                        <FichasCaptacaoPage />
                      </ProtectedRoute>
                    } />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/formulario/:token" element={<PublicFormPage />} />
                    <Route path="/revisao-contrato/:token" element={<RevisaoContratoPage />} />
                  <Route path="/" element={
                    <>
                      <Header />
                      <HomePage />
                      <Footer />
                    </>
                  } />
                  <Route path="/busca" element={
                    <>
                      <Header />
                      <SearchPage />
                      <Footer />
                    </>
                  } />
                  <Route path="/quem-somos" element={
                    <>
                      <Header />
                      <AboutPage />
                      <Footer />
                    </>
                  } />
                  <Route path="/imovel/:id" element={
                    <>
                      <Header />
                      <PropertyDetailPage />
                      <Footer />
                    </>
                  } />
                  <Route path="/tour/:id" element={<TourVirtualPage />} />
                  <Route path="/tours" element={
                    <>
                      <Header />
                      <ToursPage />
                      <Footer />
                    </>
                  } />
                  <Route path="/tour-view/:slug" element={<TourViewPage />} />
                  <Route path="/zap.xml" element={<XmlFeedPage />} />
                   <Route path="/trabalhe-conosco" element={<TrabalheConoscoPage />} />
                   <Route path="/vagas" element={<VagasPage />} />
                   <Route path="/vaga/:id" element={<VagaDetalhePage />} />
                   <Route path="/politica-privacidade" element={
                     <>
                       <Header />
                       <PrivacyPolicyPage />
                       <Footer />
                     </>
                   } />
                   <Route path="/google-calendar-callback" element={<GoogleCalendarCallback />} />
                   <Route path="/reativar" element={
                     <>
                       <Header />
                       <div className="min-h-screen bg-background py-20">
                         <div className="container mx-auto px-4 text-center">
                           <h1 className="text-4xl font-bold text-primary mb-4">Obrigado pelo seu interesse!</h1>
                           <p className="text-xl text-muted-foreground mb-8">
                             Recebemos sua solicitação de reativação. Nossa equipe entrará em contato em breve!
                           </p>
                           <p className="text-lg text-muted-foreground">
                             📞 Entre em contato conosco: <strong>(11) 99999-9999</strong>
                           </p>
                         </div>
                       </div>
                       <Footer />
                     </>
                   } />
                    </Routes>
                    <PWAInstallPrompt />
                    <PWAUpdateNotification />
                    <Toaster />
                </div>
            </Router>
          </PropertyProvider>
        </CondominiumProvider>
      </ClientProvider>
    </UserProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;